const top_error = document.getElementsByClassName("c_error")[0];
const company_name = document.getElementsByName('spree_user[department][company][company_name]')[0];
const position_id = document.getElementsByName('spree_user[position_id]')[0];
const firstname = document.getElementsByName('spree_user[firstname]')[0];
const lastname = document.getElementsByName('spree_user[lastname]')[0];
const lastname_kana = document.getElementsByName('spree_user[lastname_kana]')[0];
const firstname_kana = document.getElementsByName('spree_user[firstname_kana]')[0];
const phone = document.getElementsByName('spree_user[phone]')[0];
const email = document.getElementsByName('spree_user[email]')[0];
const email_confirmation = document.getElementsByName('spree_user[email_confirmation]')[0];
const industry_id = document.getElementsByName('spree_user[department][company][industry_id]')[0];
const occupation_id = document.getElementsByName('spree_user[department][occupation_id]')[0];
const employee_size_id = document.getElementsByName('spree_user[department][company][employee_size_id]')[0];
const password = document.getElementsByName('spree_user[password]')[0];
const password_confirmation = document.getElementsByName('spree_user[password_confirmation]')[0];
const askul_code = document.getElementsByName('spree_user[askul_code]')[0];
const info_check = document.getElementById('check');
const confirm_button = document.getElementById('confirm_button');

function is_required_error(value) {
  return value === "";
}
function is_format_error(value, regex) {
  return value.match(regex) === null;
}
function is_confirmation_error(value1, value2) {
  return value1 !== value2;
}
function get_all_error_elements() {
  return document.querySelectorAll('[class^="p_box_form_input is_error"]')
}
function get_error_count() {
  let count = get_all_error_elements().length;

  // 横並びの項目のエラー数を加算
  if (firstname.parentNode.classList.contains("is_error")) count++;
  if (firstname_kana.parentNode.classList.contains("is_error")) count++;

  return count;
}
function display_input_error(elem, error_message, class_name = "is_error") {
  elem.parentNode.classList.add(class_name);
  elem.parentNode.style.setProperty("--error-message", `"${error_message}"`);

  // 文字数が多い場合、メッセージを表示する幅を確保する
  const max_characters_per_line = 26;
  const line_count = Math.trunc(error_message.length / max_characters_per_line) + 1;
  if (line_count > 2) {
    elem.parentNode.style.paddingBottom = `${1.6 * line_count}rem`;
  }
}
function hide_all_input_error() {
  const error_elem = get_all_error_elements();
  error_elem.forEach(elem => {
    elem.classList.remove("is_error", "is_error_01", "is_error_02");
    elem.style.removeProperty("padding-bottom"); // メッセージの表示幅をもとに戻す
  });
}
// 横並び項目のエラーを表示する
function display_group_input_error(elem1, elem2) {
  let error_message1 = elem1.getAttribute("error-message") ? elem1.getAttribute("error-message") : "";
  let error_message2 = elem2.getAttribute("error-message") ? elem2.getAttribute("error-message") : "";

  // どちらも空文字の場合、何もしない
  if (error_message1 == "" && error_message2 == "") return;

  if (error_message1 != "" && error_message2 != "") {
    // どちらも空文字でない場合、改行とともに文字列を結合
    display_input_error(elem1, `${error_message1}\\A${error_message2}`);
  } else if (error_message1 != "") {
    display_input_error(elem1, `${error_message1}`, "is_error_01");
  } else if (error_message2 != "") {
    display_input_error(elem2, `${error_message2}`, "is_error_02");
  }
}
function set_error_text(elem, error_message) {
  elem.setAttribute("error-message", error_message);
}
function remove_all_error_text(){
  const error_elem = document.querySelectorAll("[error-message]");
  error_elem.forEach(elem => {
    elem.setAttribute("error-message", "");
  });
}
function hide_top_error() {
  top_error.style.display = "none";
}
function display_top_error() {
  top_error.style.display = "";
}
function display_server_validation_error() {
  const error_tag = document.querySelector("#validation_errors");
  const error_str = error_tag.dataset.errorJson;
  // エラーが空であれば終了
  if (error_str === "") return;
  const errors = JSON.parse(error_str.replaceAll('\'', '\"'));

  // 横並び項目のエラーを表示
  if(errors["firstname"]?.length > 0) set_error_text(firstname, `名${errors["firstname"][0]}`);
  if(errors["lastname"]?.length > 0) set_error_text(lastname, `姓${errors["lastname"][0]}`);
  display_group_input_error(lastname, firstname);

  if(errors["department.company.company_name"]?.length > 0) display_input_error(company_name, `企業名${errors["department.company.company_name"][0]}`);
  if(errors["email"]?.length > 0) display_input_error(email, `メールアドレス${errors["email"][0]}`);
  if(errors["email_confirmation"]?.length > 0) display_input_error(email_confirmation, `メールアドレス（確認）${errors["email_confirmation"][0]}`);
  if(errors["password"]?.length > 0) display_input_error(password, `パスワード${errors["password"][0]}`);
  if(errors["password_confirmation"]?.length > 0) display_input_error(password_confirmation, `パスワード（確認）${errors["password_confirmation"][0]}`);
  if(errors["askul_code"]?.length > 0) display_input_error(askul_code, `アスクルサービスお問い合わせ番号${errors["askul_code"][0]}`);

  if (get_error_count() > 0) display_top_error();
}
function scrollToTop() {
  $('body,html').animate({ scrollTop: 0 }, 500, 'swing');
}
function scrollToFirstErrorElement() {
  const elem = $('[class^="p_box_form_input is_error"]');
  if (elem.length) $('html, body').animate({ scrollTop: elem.first().position().top }, 500, 'swing');
}
function scrollToError(error_count) {
  if (error_count > 1) {
    // 画面トップにスクロール
    scrollToTop();
  } else {
    // 最初のエラー要素の位置にスクロール
    scrollToFirstErrorElement();
  }
}
function get_escaped_value(value) {
  return value.replaceAll('"', '\\"');
}

// 画面表示時の処理
window.addEventListener('pageshow', function() {
  // 入力内容の確認ボタンの活性状態を操作
  confirm_button.disabled = !info_check.checked;

  // 画面表示時にサーバー側のエラーを表示
  display_server_validation_error();

  scrollToError(get_error_count());
});

const check_form = document.getElementById('js_check_form');

check_form.addEventListener('submit', function(event){
  // エラーのリセット
  hide_top_error();
  hide_all_input_error();
  remove_all_error_text();

  // 入力フォーマットチェック 
  if (is_format_error(phone.value, /^0[0-9]{9,10}$/)) display_input_error(phone, "指定されている形式で入力してください。");
  if (is_format_error(email.value, /^[\w+\-.]+@[a-z\d\-]+(\.[a-z\d\-]+)*\.[a-z]+$/)) display_input_error(email, "メールアドレスは不正な値です。");
  if (is_format_error(email.value, /^[\w+\-.]+@[\.a-z\d\-]+$/)) display_input_error(email, "メールアドレスは不正な値です。ドメインは半角のアルファベット、数字、ハイフンで入力してください");
  if (is_format_error(email.value, /^[\w+\-.]+@.*\..*$/)) display_input_error(email, "メールアドレスは不正な値です。ドメインに.（ドット）が含まれているか確認ください");
  if (is_format_error(email.value, /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@.+$/)) display_input_error(email, `「${get_escaped_value(email.value)}」は完全なメールアドレスではありません。「@」に続く文字列を入力してください。`);
  if (is_format_error(email.value, /^.*@.*$/)) display_input_error(email, `メールアドレスに「@」を挿入してください。「${get_escaped_value(email.value)}」内に「@」がありません。`);
  if (is_format_error(password.value, /^(?=.*?[A-Za-z])(?=.*?[0-9])/)) display_input_error(password, "パスワードは半角英数字それぞれ１種類以上含めてご入力ください");
  if (is_format_error(password.value, /^.{8,15}$/)) display_input_error(password, "パスワードは8文字以上15文字以内で入力してください");
  if (is_format_error(askul_code.value, /^[0-9]*$/)) display_input_error(askul_code, "アスクルIDは半角数字のみ使用できます");

  // 必須チェック
  if (is_required_error(company_name.value)) display_input_error(company_name, "企業名を入力してください");
  if (is_required_error(position_id.value)) display_input_error(position_id, "リスト内の項目を選択してください");
  if (is_required_error(phone.value)) display_input_error(phone, "連絡先電話番号を入力してください");
  if (is_required_error(email.value)) display_input_error(email, "メールアドレスを入力してください");
  if (is_required_error(industry_id.value)) display_input_error(industry_id, "リスト内の項目を選択してください");
  if (is_required_error(occupation_id.value)) display_input_error(occupation_id, "リスト内の項目を選択してください");
  if (is_required_error(employee_size_id.value)) display_input_error(employee_size_id, "リスト内の項目を選択してください");
  if (is_required_error(password.value)) display_input_error(password, "パスワードを入力してください");
  if (is_required_error(password_confirmation.value)) display_input_error(password_confirmation, "パスワード（確認）を入力してください");
  if (is_required_error(email_confirmation.value)) display_input_error(email_confirmation, "メールアドレス（確認）を入力してください");

  // 一致チェック
  if (is_confirmation_error(password.value, password_confirmation.value)) display_input_error(password_confirmation, "パスワードが一致しません");
  if (is_confirmation_error(email.value, email_confirmation.value)) display_input_error(email_confirmation, "メールアドレスが一致しません");


  // 横並び項目のチェック
  // 入力フォーマットチェック 
  if (is_format_error(firstname_kana.value, /^[ァ-ンー　]+$/)) set_error_text(firstname_kana, "メイは全角カタカナで入力してください");
  if (is_format_error(lastname_kana.value, /^[ァ-ンー　]+$/)) set_error_text(lastname_kana, "セイは全角カタカナで入力してください");

  // 必須チェック
  if (is_required_error(firstname.value)) set_error_text(firstname, "名を入力してください");
  if (is_required_error(lastname.value)) set_error_text(lastname, "姓を入力してください");
  if (is_required_error(lastname_kana.value)) set_error_text(lastname_kana, "セイを入力してください");
  if (is_required_error(firstname_kana.value)) set_error_text(firstname_kana, "メイを入力してください");

  // 横並び項目のエラーを表示
  display_group_input_error(lastname, firstname);
  display_group_input_error(lastname_kana, firstname_kana);


  const error_count = get_error_count();
  if (error_count > 0) {
    event.preventDefault();

    display_top_error();
    scrollToError(error_count);
  } else {
    // 二重送信を防ぐ
    confirm_button.disabled = true;
  }
});
